import React, { useEffect } from 'react';
import { Layout, Row, Col } from 'antd';
import { useDispatch } from 'react-redux';
import InnerHeader from '../../component/InnerHeader';
import RegisterDomain from '../../component/RegisterDomain/index';

const RegisterDomainsPage = () => {
  const dispatch = useDispatch();

  //   const { contentId } = useParams();
  //   const [isSaveEnabled, setSaveEnabled] = useState(true);

  useEffect(() => {
    // async function load() {
    //   dispatch(fetchContentById(contentId, true));
    // }
    // load();
  }, [dispatch]);

  const actions = [];

  const onBack = () => {
    window.history.back();
  };

  return (
    <Layout>
      <InnerHeader actions={actions} onBack={onBack} title="Register Domain" />

      <Layout
        style={{
          height: 'calc(100vh - 235px)',
          overflowY: 'scroll',
          paddingLeft: '24px',
          paddingTop: '24px'
        }}
      >
        <Row>
          <Col
            span={24}
            style={{
              paddingRight: '24px'
            }}
          >
            <RegisterDomain />
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
};

export default RegisterDomainsPage;
